import React from "react"
import { add, format } from "date-fns"
import { MdWarning, MdAlarm } from "react-icons/md"
import { Button, Link } from "gatsby-interface"
import { useUnblockOrganization } from "@modules/organization/shared/hooks/useUnblockOrganization"

export function MarketingBanner({
  orgWillBeBlockedAt,
  orgId,
  orgCanBeUnblocked,
}) {
  const { unblock, unblocking, unblockingError } = useUnblockOrganization(orgId)
  const Icon = orgWillBeBlockedAt ? MdAlarm : MdWarning

  if (typeof orgWillBeBlockedAt === `undefined`) {
    return null
  }

  return (
    <aside
      css={theme => [
        wrapperStyles(theme),
        orgWillBeBlockedAt && { background: theme.colors.orange[80] },
      ]}
    >
      <span
        css={theme => [
          textStyles(theme),
          orgWillBeBlockedAt && {
            color: theme.colors.white,
          },
        ]}
      >
        <Icon css={theme => [iconStyles(theme)]} /> Gatsby Cloud is being
        discontinued.{" "}
        <Link href="https://www.netlify.com/blog/gatsby-cloud-evolution/?utm_source=gatsby_cloud&utm_medium=banner">
          Learn more
        </Link>{" "}
      </span>
      <span
        css={theme => [
          textStyles(theme),
          orgWillBeBlockedAt && {
            color: theme.colors.white,
          },
        ]}
      >
        {orgWillBeBlockedAt && (
          <>
            The workspace will be suspended on{" "}
            <b>{format(new Date(orgWillBeBlockedAt), "MMMM do 'at' h:mm b")}</b>
            .
          </>
        )}
        {orgCanBeUnblocked && orgWillBeBlockedAt && (
          <>
            <br /> For a one-time access extension until{" "}
            <b>
              {format(
                add(new Date(orgWillBeBlockedAt), { days: 30 }),
                `LLLL dd, yyyy`
              )}
            </b>{" "}
            press the button.{" "}
            <Button
              size="S"
              onClick={unblock}
              disabled={unblocking}
              loading={unblocking}
            >
              Extend access
            </Button>
          </>
        )}
        {unblockingError && (
          <>
            <br />
            <div css={errorStyles}>{unblockingError}</div>
          </>
        )}
      </span>
    </aside>
  )
}

const wrapperStyles = theme => ({
  padding: `${theme.space[6]}`,
  background: theme.colors.purple[90],
  color: theme.colors.whiteFade[80],
  fontSize: theme.fontSizes[1],
  transformOrigin: `top center`,
  textAlign: `center`,

  a: {
    color: theme.colors.white,
    opacity: 0.9,

    ["&:hover"]: {
      opacity: 1,
      color: theme.colors.white,
    },
  },
})

const textStyles = theme => ({
  alignItems: `center`,
  textAlign: `center`,
  fontSize: theme.fontSizes[3],
})

const iconStyles = theme => ({
  width: theme.fontSizes[6],
  height: `auto`,
  margin: `0 ${theme.space[2]}`,
  verticalAlign: `sub`,
})

const errorStyles = theme => ({
  fontSize: theme.fontSizes[1],
  background: theme.colors.red[70],
  display: `inline-block`,
  padding: `${theme.space[1]} ${theme.space[4]} ${theme.space[2]}`,
  marginTop: theme.space[2],
})
